$('.media-carousel').each(function () {
  const $this = $(this)
  const $container = $this.closest('.carousel-container')

  const swiper = new Swiper(this, {
    navigation: {
      nextEl: $container.find('.carousel-next')[0],
      prevEl: $container.find('.carousel-previous')[0],
    },
    grabCursor: true,
    slidesPerView: 1,
    spaceBetween: 20,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    speed: 1000,
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return `
        <span class="${className} circle-wrap">
            <svg viewBox="0 0 36 36" class="circular-chart absolute top-0 left-0">
              <path class="circle"
                    stroke-dasharray="60, 100"
                    d="M18 2.0845
                    a 15.9155 15.9155 0 0 1 0 31.831
                    a 15.9155 15.9155 0 0 1 0 -31.831"
              />
            </svg>
            ${index + 1}
        </span>`
      },
    },
    on: {
      slideChangeTransitionStart: function () {
        $container.find('.swiper-pagination').removeClass('first-run')

        // Reset the animation for the progress bar
        const bullets = $container.find('.swiper-pagination-bullet')
        if (bullets) {
          bullets.forEach((bullet) => {
            bullet.style.setProperty('--progress', '0%') // Reset progress
          })

          const activeBullet = $container.find('.swiper-pagination-bullet-active')
          activeBullet.style.animation = 'none' // Pause animation
          void activeBullet.offsetWidth // Trigger reflow
          activeBullet.style.animation = '' // Restart animation
        }
      },
    },
  })
})

$('.floor-carousel').each(function () {
  const $this = $(this)

  let initialSlideIndex = $this.find('.swiper-slide[data-initial-slide="1"]').index()
  if (initialSlideIndex === -1) {
    initialSlideIndex = 0 // Default to first slide if no data-initial-slide is set
  }

  let swiper = new Swiper(this, {
    grabCursor: false,
    slidesPerView: 1,
    spaceBetween: 0,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    loop: false,
    allowTouchMove: false,
    initialSlide: initialSlideIndex,
    navigation: {
      prevEl: $this.closest('.floor-carousel-container').find('.carousel-previous')[0],
      nextEl: $this.closest('.floor-carousel-container').find('.carousel-next')[0],
    },
    pagination: {
      el: $this.closest('.floor-carousel-container').find('.floor-bullets')[0],
      clickable: true,
      renderBullet: function (index, className) {
        const title = $this
          .closest('.floor-carousel-container')
          .find('.floor-slide')
          .eq(index)
          .attr('data-title')

        return (
          '<div class="floor-bullet h-auto w-full opacity-100 !mx-0 !px-3 !py-2 !rounded-none hover:bg-taupe rounded-0 bg-transparent !text-left ' +
          className +
          '">' +
          title +
          '</div>'
        )
      },
    },
    on: {
      slideChange: function () {
        // Update the title on slide change
        const activeIndex = this.activeIndex
        const title = $this
          .closest('.floor-carousel-container')
          .find('.floor-slide')
          .eq(activeIndex)
          .attr('data-title')

        // Update the title in the floor toggle button
        $('.floor-toggle-button .floor-title').html(title + ':')

        $('.position-selector').attr('data-active-selection', activeIndex)
      },
    },
  })

  $this
    .closest('.floor-carousel-container')
    .find('.floor-bullet')
    .on('click', function () {
      toggleFloorOptions()

      $('.floor-toggle-button .floor-title').html($(this).html())
    })

  $('.position-selector').attr('data-active-selection', initialSlideIndex)
})

$('.floor-toggle-button').on('click', function () {
  toggleFloorOptions()
})

function toggleFloorOptions() {
  $('.floor-toggle-options').slideToggle(300)
  $('.floor-toggle-options-container').toggleClass('!bg-soft-off-white')
  $('.floor-toggle-button .icon').toggleClass('rotate-45')
}

$('[data-floor-select]').on('click', function (event) {
  let $this = $(this)
  let $parent = $this.parents('.floorplans-container')
  let toggleClasses = 'font-bold pointer-events-none hover:!text-gra hover:bg-oransje'
  let floor = $this.attr('data-floor-select')
  let index = $('[data-floor="' + floor + '"]').index()

  $parent.find('.floorplans-carousel').each(function () {
    let swiperElement = $(this)[0]
    let swiper = swiperElement.swiper
    swiper.slideTo(index)
  })

  $parent.find('.floorplans-info-carousel').each(function () {
    let swiperElement = $(this)[0]
    let swiper = swiperElement.swiper
    swiper.slideTo(index)
  })

  $('.position-selector').attr('data-active-selection', index)

  $parent
    .find('.floor-toggle [data-floor-select]')
    .not('[data-floor-select="' + floor + '"]')
    .removeClass(toggleClasses)
  $parent.find('.floor-toggle [data-floor-select="' + floor + '"]').addClass(toggleClasses)

  $parent.find('.position-selector a').removeClass('active')
  $parent.find('.position-selector [data-floor-select=' + floor + ']').addClass('active')

  // $parent.find( '.floor-title' ).html( $this.html() );
})
